module.exports = __webpack_public_path__ + "static/medianet-white-5408fbbf3e6e8ef907c3f92605507d81.svg";